export default {
  // Menu
  'menu.book': '典籍浏览',
  'menu.search': '典籍查询',
  'menu.occurrence':'共现分析',
  'menu.reuse': '复用分析',
  'menu.diachronicngram':'历时 N-gram',
  'menu.frequency': '词频分析',
  'menu.frequency.ngram': 'n-gram统计',
  'menu.frequency.word': '字词统计', //字词粒度
  'menu.frequency.contrast': '历时对比',
  'menu.frequency.evolution': '词义演化',
  'menu.about': '关于我们',
  // Book
  // Book Overview Dynamic
  'book.overview.dynamic.text_reuse': '复用分析',
  'book.overview.dynamic.switch_on': '开',
  'book.overview.dynamic.switch_off': '关',
  'book.overview.dynamic.author': '作者：',
  'book.overview.dynamic.editor': '编者：',
  'book.overview.dynamic.publication_time': '成书时代：',
  'book.overview.dynamic.recording_time': '记叙时代：',
  // Book Overview Card
  'book.overview.card.author': '作者',
  'book.overview.card.time': '时代',
  'book.overview.card.subject': '类目',
  // Search
  // Search.SearchPage
  'search.search_page.tab_list.book': '书目结果',
  'search.search_page.tab_list.content': '全文结果',
  'search.search_page.tab_list.empty': ' ',
  // Search.AdvancedSearch
  'search.advanced_search.form.search_button': '搜索',
  'search.advanced_search.form.scope_constraint': '范围约束为',
  'search.advanced_search.form.scope_select_sentence': '句子',
  'search.advanced_search.form.scope_select_paragraph': '段落',
  'search.advanced_search.form.scope_select_chapter': '篇章',
  'search.advanced_search.form.scope_select_book': '书本',
  'search.advanced_search.form.search_scope_title': '检索范围：',
  'search.advanced_search.form.search_scope_book_title': '书名',
  'search.advanced_search.form.search_scope_chapter_title': '篇章名',
  'search.advanced_search.form.search_scope_author': '作者',
  'search.advanced_search.form.search_scope_full_text': '全文',
  'search.advanced_search.form.search_mode_title': '检索模式：',
  'search.advanced_search.form.search_mode_fuzzy': '模糊查询',
  'search.advanced_search.form.range_select_title': '书目范围：',
  // Search.AdvancedSearch.RangeSelect
  'search.advanced_search.range_select.category': '按类别',
  'search.advanced_search.range_select.time': '按时代',
  'search.advanced_search.range_select.select_placeholder': '书目范围选择',
  // Search.AdvancedSearch.MySearch
  'search.advanced_search.my_search.select_all': '全选',
  // Search.Book
  'search.book.result.secondary_earch': '二次检索：',
  'search.book.result.visualization': '结果可视化：',
  'search.book.result.book_search_result': '书目检索结果：',
  // Search.Book.BookResult
  'search.book.book_result.category': '按类目',
  'search.book.book_result.dynasty': '按时代',
  'search.book.book_result.total': '共 {total} 条结果',
  // Search.Book.BookResult.Card
  'search.book.book_result.card.author': '作者：',
  'search.book.book_result.card.time': '时代：',
  'search.book.book_result.card.subject': '类目：',
  // Search.Content
  'search.content.result.secondary_earch': '二次检索：',
  'search.content.result.visualization': '结果可视化：',
  'search.content.result.content_search_result': '内容检索结果：',
  'search.content.result.content_result.book_name': '書名',
  'search.content.result.content_result.author': '作者',
  'search.content.result.content_result.time': '時代',
  'search.content.result.content_result.subject': '類目',
  'search.content.result.content_result.text': '文本',
  // Search.QuadraticSearch
  'search.quadratic_search.input.placeholder': '在结果中检索',
  'search.quadratic_search.button.confirm': '确定',
  // Search.QuadraticSearch.ResultRange
  'search.quadratic_search.result_range.in_result': '在结果所在',
  'search.quadratic_search.result_range.in_result_sentence': '句子',
  'search.quadratic_search.result_range.in_result_paragraph': '段落',
  'search.quadratic_search.result_range.in_result_chapter': '篇章',
  'search.quadratic_search.result_range.in_result_book': '书目',
  'search.quadratic_search.result_range.in_result_statistics': '中统计',
  'search.quadratic_search.result_range.in_paragraph_result': '在结果所在段落中统计',
  'search.quadratic_search.result_range.in_chapter_result': '在结果所在篇章中统计',
  'search.quadratic_search.result_range.in_book_result': '在结果所在书目中统计',
  // Search.VisualizedResult
  'search.visualized_result.time': '时代分布',
  'search.visualized_result.subject': '类目分布',
  'search.visualized_result.top_k_words': 'TopK 词汇',
  'search.visualized_result.top_k_words.top': '词汇量选取Top',
  // Search.VisualizedResult.VisualDualAxes
  'search.visualized_result.visual_dual_axes.meta_count': '出現頻次',
  'search.visualized_result.visual_dual_axes.meta_frequency': '出現頻率',
  'search.visualized_result.visual_dual_axes.legend_count': '出現頻次',
  'search.visualized_result.visual_dual_axes.legend_frequency': '出現頻率(%)',
  'search.visualized_result.visual_dual_axes.book_meta_count': '出現頻次',
  // Search.VisualizedResult.WordCloudSelect
  'search.visualized_result.word_cloud_select.in_result': '在结果所在',
  'search.visualized_result.word_cloud_select.in_result_sentence': '句子',
  'search.visualized_result.word_cloud_select.in_result_paragraph': '段落',
  'search.visualized_result.word_cloud_select.in_result_chapter': '篇章',
  'search.visualized_result.word_cloud_select.in_result_book': '书目',
  'search.visualized_result.word_cloud_select.in_result_statistics': '中统计',
  // Reuse
  'reuse.range.select.category': '按类别',
  'reuse.range.select.dynasty': '按时代',
  'reuse.range.select.all': '全选',
  'reuse.range.select.placeholder': '请选择要检索的书目集合',
  'reuse.range.setting.select.analysis.books': '选择复用分析书目：',
  'reuse.range.setting.select.search.books': '选择复用分析书目集合：',
  'reuse.range_setting': '分析范围设置',
  'reuse.reuse_result': '复用分析结果',
  'reuse.next': '下一步',
  'reuse.reselect': '重新选择',
  'reuse.tab_book': '书本粒度',
  'reuse.tab_chapter': '篇章粒度',
  'reuse.tab_sentence': '句子粒度',
  // Reuse.Book.BookReuse
  'reuse.book.book_reuse.scope_selection_1': '分析书目',
  'reuse.book.book_reuse.scope_selection_2': '范围选择',
  'reuse.book.book_reuse.total_frequency': '总复用频次是 {total}',
  'reuse.book.book_reuse.arc_graph': '弧形图',
  'reuse.book.book_reuse.arc_result': '复用结果列表',
  // Reuse.Chapter.ChapterReuse
  'reuse.chapter.chapter_reuse.book': '书目',
  'reuse.chapter.chapter_reuse.select_book': '选择分析书目',
  'reuse.chapter.chapter_reuse.total_reuse_freq':
    '所选范围内总复用频次是{freq}次',
  // Reuse.Sentence
  'reuse.sentence.alertMessage':
    '《{selectedBook}》在所选择的书目中共被复用{total}次',
  'reuse.sentence.title': '复用句：{titlelst}',
  'reuse.sentence.return': '返回',
  'reuse.sentence.alert': '该句在本系统所收录的所有书目中共复用{totalreuse}次',
  'reuse.sentence.book': '分析书目',
  // Frequency
  // Frequency.Ngram
  'Frequency.ngram.analysis_setting': '分析条件设置',
  'Frequency.ngram.statistical_range': '统计范围',
  'Frequency.ngram.analysis_granularity': '分析粒度',
  'Frequency.ngram.matching_dictionary': '匹配词典',
  'Frequency.ngram.chinese_dict': '汉语大词典',
  'Frequency.ngram.stopword_table': '停用字表',
  'Frequency.ngram.use_stopwords': '使用停用字',
  'Frequency.ngram.edit_stopwords': '修改字表',
  'Frequency.ngram.preset_table_selection': '预设字表选择：',
  'Frequency.ngram.select_all': '全选',
  'Frequency.ngram.custom_stopwords': '自定义停用词：',
  'Frequency.ngram.split_with_newline': '以换行符\\n分割可自动分词',
  'Frequency.ngram.submit': '提交',
  'Frequency.ngram.statistics_list': '统计列表',
  'Frequency.ngram.unigram': 'unigram',
  'Frequency.ngram.bigram': 'bigram',
  'Frequency.ngram.trigram': 'trigram',
  'Frequency.ngram.4-gram': '4-gram',
  'frequency.ngram.index': '序号',
  'frequency.ngram.word': '单词',
  'frequency.ngram.count': '计数（次）',
  'frequency.ngram.ratio': '占比（‰）',
  // Frequency.RangeSelectBar.RangeSelect
  'frequency.range_select_bar.range_select.category': '按类别',
  'frequency.range_select_bar.range_select.time': '按时代',
  'frequency.range_select_bar.range_select.time_log':'按记录年代',
  'frequency.range_select_bar.range_select.select_all': '全选',
  'frequency.range_select_bar.range_select.placeholder':
    '请选择要检索的书目集合',
  // Frequency.Word.WordPage
  'frequency.word.word_page.analysis_range_selection': '分析范围选择',
  'frequency.word.word_page.statistical_range': '统计范围',
  'frequency.word.word_page.dict_matching': '匹配词典',
  'frequency.word.word_page.stopwords': '停用字表',
  'frequency.word.word_page.use_stopwords': '使用停用字',
  'frequency.word.word_page.modify_table': '修改字表',
  'frequency.word.word_page.stopwords_setting': '停用字设置',
  'frequency.word.word_page.use_preset_stopwords': '预设字表选择：',
  'frequency.word.word_page.custom_stopwords': '自定义停用词：',
  'frequency.word.word_page.submit': '确认',
  'frequency.word.word_page.select_all': '全选',
  'frequency.word.word_page.analysis_list': '统计列表',
  'frequency.word.word_page.tooltip':
    '【note】呈现词汇的使用频次和历时变化趋势',
  'frequency.word.word_page.tooltip2':
    '【note】允许用户自定义停用字表对结果进行过滤',
  'frequency.word.word_page.line_chart': '折线图',
  'frequency.word.word_page.bar_chart': '柱状图',
  'frequency.word.word_page.chinese_dict': '汉语大词典',
  'frequency.word.word_page.split_with_newline': '以',
  'frequency.word.word_page.split_with_newline2': '换行符\\n',
  'frequency.word.word_page.split_with_newline3': '分割可自动分词',
  'frequency.word.word_page.id': '序号',
  'frequency.word.word_page.word': '词语',
  'frequency.word.word_page.count': '词频（次）',
  'frequency.word.word_page.frequency': '频率（‰）',
  // Frequency.Contrast.WordPage
  'frequency.contrast.word_page.content':
    '支持同时输入多个词语或词组，比较不同检索语在特定时间范围内的出现频率。',
  'frequency.contrast.word_page.analysis_condition_setting': '分析条件设置',
  'frequency.contrast.word_page.analysis_vocabulary': '分析词汇',
  'frequency.contrast.word_page.input_vocabulary':
    '最多输入10个词，每个词不超过10个字',
  'frequency.contrast.word_page.statistics_range': '统计范围',
  'frequency.contrast.word_page.submit': '提交',
  'frequency.contrast.word_page.time_range': '时间范围',
  //'frequency.contrast.word_page.line_chart': '检索结果-历时折线图',
  'frequency.contrast.word_page.publictime_chart': '历时折线图-按成书时代',
  'frequency.contrast.word_page.recordingtime_chart': '历时折线图-按记叙时代',
  // About
  'about.lab_website': '实验室网站：{labWebsite}',
  'about.supervisor': '指导老师',
  'about.supervisor.name': '王军、苏祺、杨浩',
  'about.platform.architecture': '平台架构与算法设计',
  'about.platform.architecture.name': '段思宇',
  'about.platform.interaction': '平台交互设计',
  'about.platform.interaction.name': '李佳纯',
  'about.platform.development': '平台开发',
  'about.platform.development.name': '罗睿轩、毕潇晗',
  // Sentence
  'sentence.dynamic.id': '序号',
  'sentence.dynamic.reuse': '复用句',
  'sentence.dynamic.source': '来源',
  'sentence.dynamic.total_reuse':'该句在本系统所收录的所有书目中的复用如下：',
  //  '该句在本系统所收录的所有书目中共复用{totalReuse}次',
};
